module.exports = __webpack_public_path__ + "static/media/ruta.5481dec5.svg";